import { NavArrowDown } from 'iconoir-react';
import { FC } from 'react';
import { Link as LinkNative, LinkProps, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import ListNative from '~/components/List';
import Menu from '~/components/Menu';
import Role from '~/components/Role';
import Text from '~/components/Text';

const Label = styled(Text)`
  cursor: pointer;
  display: flex;
  font-size: 12px;
  color: ${p => p.theme.colors.gra600};
  align-items: center;
`;

const List = styled(ListNative)`
  width: 116px;
  border-radius: 10px;
`;

const Item = styled(ListNative.Item)`
  padding: 0 16px;
`;

const Link = styled<LinkProps>(props => <LinkNative {...props} />)`
  text-decoration: none;
`;

interface SelectRealmProps {
  activeRealm: string;
  byId: {
    id: string;
    name: string;
    companyName: string;
  };
  allIds: string[];
}

const SelectRealm: FC<SelectRealmProps> = ({
  activeRealm = '',
  allIds = [],
  byId = {}
}) => {
  const location = useLocation();

  return (
    <Menu
      data-testid='realm-selection-menu'
      component={({ toggle }) => (
        <Label data-testid='selected-text' onClick={toggle} weight='regular'>
          Realm: {activeRealm}
          <Role name={['GROUP:SUPPORT', 'ORG:MANAGER']}>
            <NavArrowDown className='icon-smallest ml-4' />
          </Role>
        </Label>
      )}
    >
      {({ toggle }) => (
        <Role name={['GROUP:SUPPORT', 'ORG:MANAGER']}>
          {allIds.length > 1 && (
            <List inset noHairlines>
              {allIds?.map(id => (
                <Link
                  key={id}
                  to={location.pathname.replace(activeRealm, byId[id]?.name)}
                  data-testid='link'
                  onClick={() => {
                    toggle(false);
                  }}
                >
                  <Item>
                    <Text data-testid='value-text' align='left'>
                      {byId[id]?.companyName}
                    </Text>
                  </Item>
                </Link>
              ))}
            </List>
          )}
        </Role>
      )}
    </Menu>
  );
};

export default SelectRealm;
